import React, { useState, useEffect } from "react";
import SelectTransferMember from "./selectTransferMember";
import useQuery from "../../shared/utils/queryParams";
import Loader from "../../shared/components/loader";
import ErrorMessage from "../../shared/components/errorMessage";
// import getMockFamilyData from "./mockFamilyData";

function SelectTransferMemberContainer() {
  const [members, setMembers] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessageText, setShowErrorMessageText] = useState(undefined);

  const query = useQuery();

  const getErrorMessage = (code) => {};

  useEffect(() => {});

  // return showErrorMessage ? (
  //   <ErrorMessage title={"Error"} message={errorMessageText}></ErrorMessage>
  // ) : members.length ? (
  //   <SelectTransferMember members={members}></SelectTransferMember>
  // ) : (
  //   <Loader></Loader>
  // );

  return <SelectTransferMember members={members}></SelectTransferMember>;
}

export default SelectTransferMemberContainer;
